export const DEVIS = {
  lecture: { module: 'bodac', element: 'devis', rule: 'lecture' },
  maj: { module: 'bodac', element: 'devis', rule: 'maj' },
  exporter: { module: 'bodac', element: 'devis', rule: 'exporter' },
  editer: { module: 'bodac', element: 'devis', rule: 'edition' },
  supprimer: { module: 'bodac', element: 'devis', rule: 'supprimer' },
};

export const FACTURES = {
  lecture: { module: 'bodac', element: 'factures', rule: 'lecture' },
  maj: { module: 'bodac', element: 'factures', rule: 'maj' },
  exporter: { module: 'bodac', element: 'factures', rule: 'exporter' },
  editer: { module: 'bodac', element: 'factures', rule: 'edition' },
  supprimer: { module: 'bodac', element: 'factures', rule: 'supprimer' },
};

export const TIERS = {
  lecture: { module: 'bodac', element: 'clients/contacts', rule: 'lecture' },
  maj: { module: 'bodac', element: 'clients/contacts', rule: 'maj' },
  exporter: { module: 'bodac', element: 'clients/contacts', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'clients/contacts', rule: 'supprimer' },
};

export const COMMANDES = {
  lecture: { module: 'bodac', element: 'commandes', rule: 'lecture' },
  maj: { module: 'bodac', element: 'commandes', rule: 'maj' },
  exporter: { module: 'bodac', element: 'commandes', rule: 'exporter' },
  editer: { module: 'bodac', element: 'commandes', rule: 'edition' },
  supprimer: { module: 'bodac', element: 'commandes', rule: 'supprimer' },
};

export const REMISES_BANCAIRES = {
  lecture: { module: 'bodac', element: 'remises_bancaires', rule: 'lecture' },
  maj: { module: 'bodac', element: 'remises_bancaires', rule: 'maj' },
  exporter: { module: 'bodac', element: 'remises_bancaires', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'remises_bancaires', rule: 'supprimer' },
  editer: { module: 'bodac', element: 'remises_bancaires', rule: 'edition' },
};

export const JOURNAL_REGLEMENTS = {
  lecture: { module: 'bodac', element: 'journal_reglements', rule: 'lecture' },
  maj: { module: 'bodac', element: 'journal_reglements', rule: 'maj' },
  exporter: { module: 'bodac', element: 'journal_reglements', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'journal_reglements', rule: 'supprimer' },
};

export const RELANCE = {
  lecture: { module: 'bodac', element: 'relance', rule: 'lecture' },
  maj: { module: 'bodac', element: 'relance', rule: 'maj' },
  exporter: { module: 'bodac', element: 'relance', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'relance', rule: 'supprimer' },
  editer: { module: 'bodac', element: 'relance', rule: 'edition' },
};

export const RELANCE_OPTION = {
  lecture: { module: 'bodac', element: 'relance_option', rule: 'lecture' },
  maj: { module: 'bodac', element: 'relance_option', rule: 'maj' },
  exporter: { module: 'bodac', element: 'relance_option', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'relance_option', rule: 'supprimer' },
};

export const DEMANDE_TEMPO = {
  lecture: { module: 'bodac', element: 'demande_tempo', rule: 'lecture' },
  maj: { module: 'bodac', element: 'demande_tempo', rule: 'maj' },
  exporter: { module: 'bodac', element: 'demande_tempo', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'demande_tempo', rule: 'supprimer' },
};

export const CATALOGUE = {
  lecture: { module: 'bodac', element: 'catalogue', rule: 'lecture' },
  maj: { module: 'bodac', element: 'catalogue', rule: 'maj' },
  exporter: { module: 'bodac', element: 'catalogue', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'catalogue', rule: 'supprimer' },
  editer: { module: 'bodac', element: 'catalogue', rule: 'edition' },
};

export const FORMAT = {
  lecture: { module: 'bodac', element: 'format', rule: 'lecture' },
  maj: { module: 'bodac', element: 'format', rule: 'maj' },
  supprimer: { module: 'bodac', element: 'format', rule: 'supprimer' },
};

export const TYPE_RESEAU = {
  lecture: { module: 'bodac', element: 'type_reseau', rule: 'lecture' },
  maj: { module: 'bodac', element: 'type_reseau', rule: 'maj' },
  supprimer: { module: 'bodac', element: 'type_reseau', rule: 'supprimer' },
};

export const MOTIF_BLOCAGE = {
  lecture: { module: 'bodac', element: 'motif_blocage', rule: 'lecture' },
  maj: { module: 'bodac', element: 'motif_blocage', rule: 'maj' },
  supprimer: { module: 'bodac', element: 'motif_blocage', rule: 'supprimer' },
};

export const PLANNING = {
  lecture: { module: 'bodac', element: 'planning', rule: 'lecture' },
  maj: { module: 'bodac', element: 'planning', rule: 'maj' },
  exporter: { module: 'bodac', element: 'planning', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'planning', rule: 'supprimer' },
};

export const ECHEANCIER_PAIEMENT = {
  lecture: { module: 'bodac', element: 'echeance_payement', rule: 'lecture' },
  maj: { module: 'bodac', element: 'echeance_payement', rule: 'maj' },
  exporter: { module: 'bodac', element: 'echeance_payement', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'echeance_payement', rule: 'supprimer' },
};

export const RETROCESSION = {
  lecture: { module: 'bodac', element: 'retrocession', rule: 'lecture' },
  maj: { module: 'bodac', element: 'retrocession', rule: 'maj' },
  exporter: { module: 'bodac', element: 'retrocession', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'retrocession', rule: 'supprimer' },
};

export const FACTOR = {
  lecture: { module: 'bodac', element: 'factor', rule: 'lecture' },
  maj: { module: 'bodac', element: 'factor', rule: 'maj' },
  exporter: { module: 'bodac', element: 'factor', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'factor', rule: 'supprimer' },
};

export const TRANSMISSION = {
  lecture: { module: 'bodac', element: 'transmission', rule: 'lecture' },
  maj: { module: 'bodac', element: 'transmission', rule: 'maj' },
  exporter: { module: 'bodac', element: 'transmission', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'transmission', rule: 'supprimer' },
  editer: { module: 'bodac', element: 'transmission', rule: 'edition' },
};

export const CAMPAGNE = {
  lecture: { module: 'bodac', element: 'campagne', rule: 'lecture' },
  maj: { module: 'bodac', element: 'campagne', rule: 'maj' },
  exporter: { module: 'bodac', element: 'campagne', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'campagne', rule: 'supprimer' },
};

export const IMPORT = {
  maj: { module: 'bodac', element: 'import', rule: 'maj' },
};

export const FORMAT_AFFICHE = {
  lecture: { module: 'bodac', element: 'format_affiche', rule: 'lecture' },
  maj: { module: 'bodac', element: 'format_affiche', rule: 'maj' },
  exporter: { module: 'bodac', element: 'format_affiche', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'format_affiche', rule: 'supprimer' },
};

export const BESOIN = {
  lecture: { module: 'bodac', element: 'besoin', rule: 'lecture' },
  maj: { module: 'bodac', element: 'besoin', rule: 'maj' },
  exporter: { module: 'bodac', element: 'besoin', rule: 'exporter' },
  supprimer: { module: 'bodac', element: 'besoin', rule: 'supprimer' },
};
